import React, { FC } from 'react'
import { useAbility } from '@casl/react'
import { Link } from 'react-router-dom'
import { Tabs, IconButton } from '@wmgtech/legato'
import { BrowserNotificationSection } from '..'

import { ENABLED_FEATURES } from 'shared/utils/featureFlags'
import { AbilityContext } from 'shared/abilities'
import { NOTIFICATION_TYPE_VIEW } from '../../constants'

import styles from './NotificationSideMenuHeader.module.scss'

type NotificationSideMenuHeaderProps = {
  typeView: NOTIFICATION_TYPE_VIEW
  setTypeView: (view: NOTIFICATION_TYPE_VIEW) => void
  hasNotifications: boolean
  deleteNotifications: () => void
}

export const NotificationSideMenuHeader: FC<NotificationSideMenuHeaderProps> = ({
  typeView,
  setTypeView,
  hasNotifications,
  deleteNotifications,
}) => {
  const ability = useAbility(AbilityContext)

  return (
    <div className={styles.header}>
      <h2 className={styles.headerTitle}>Notifications</h2>
      <BrowserNotificationSection />
      <div className={styles.navigation}>
        <Tabs
          list={[{
            id: NOTIFICATION_TYPE_VIEW.STORYBOX,
            title: 'Storybox'
          }, ...(ENABLED_FEATURES.GLOBALHUB && ability.can('access', 'GlobalHub') ? [{
            id: NOTIFICATION_TYPE_VIEW.GLOBALHUB,
            title: 'Global Hub'
          }] : [])]}
          initialTabId={typeView}
          mode="in-page"
          onClick={(tab) => setTypeView(tab.id as NOTIFICATION_TYPE_VIEW)}
          className={styles.tabs}
        />
        <div className={styles.actions}>
          <IconButton
            icon="circle-xmark"
            message="Clear all"
            colorType="warning"
            size="md"
            disabled={!hasNotifications}
            onClick={deleteNotifications}
            className={styles.clearIcon}
          />
          <Link className={styles.linkIcon} to="/notifications/settings">
            <IconButton icon="gears" message="Settings" size="md" />
          </Link>
        </div>
      </div>
    </div>
  )
}
